import React from 'react'
import { connect } from 'react-redux'
import ListSLRs from './ListSLRs'
import SlrBookingMenu from '../SlrBookingMenu'

const SlrBookingList = ({ gsaAgentDetails }) => {
	return (
		<>
			<SlrBookingMenu />
			<div className="slr-booking-content">
				<ListSLRs gsaAgentDetails={gsaAgentDetails} />
			</div>
		</>
	)
}

const mapStateToProps = ({ gsaAgent }) => ({
	gsaAgentDetails: gsaAgent
})

export default connect(mapStateToProps)(SlrBookingList)
